import { motion } from 'framer-motion';

import { buildMotionProps, defaultMotionProps } from './motion';
import { BlueCircle } from './Ornaments/BlueCircle';
import { Diamond } from './Ornaments/Diamond';
import { EllipsePurple } from './Ornaments/EllipsePurple';
import { LighterCircle } from './Ornaments/LighterCirlce';
import { LightPolygon } from './Ornaments/LightPolygon';
import { PinkPolygon } from './Ornaments/PinkPolygon';
import { SmallCircle } from './Ornaments/SmallCircle';
import { Star } from './Ornaments/Star';
import { WhiteCircle } from './Ornaments/WhiteCircle';

const motionProps = buildMotionProps(0.35, '0px');
export const Hero = () => {
  return (
    <section className="bg-cipher-04 mt-[calc(var(--header-height)*-1)] pb-200  pt-[calc(var(--header-height)+5rem)] relative ml:pb-300  overflow-hidden">
      <BlueCircle
        className="absolute -top-50 ml:top-20 -right-120 m:-right-300 xl:-right-430  xl:w-860 l:w-500 m:w-350 animate-move-u w-250"
        {...motionProps}
      />
      <Star
        className="absolute top-100 ml:top-30 xl:right-[30vw] m:right-[20vw] right-10 m:w-220 l:w-345 w-110 animate-[move-up_4s_ease-in-out_infinite_0.5s]"
        {...motionProps}
      />
      <Star
        className="absolute bottom-90 ml:bottom-10 ml:right-[20vw] right-30  m:w-120 l:w-290 w-90 animate-[move-down_4s_ease-in-out_infinite_1s]"
        {...motionProps}
      />
      <EllipsePurple
        className="absolute ml:-top-110 ml:left-[30vw] left-40 w-220 top-20 m:w-440 animate-[move-up_3s_ease-in-out_infinite_0.3s]"
        {...motionProps}
      />
      <PinkPolygon
        className="absolute top-190 ml:top-290 -right-20 ml:right-90 w-70 xl:w-380 m:w-280 animate-[move-down_3s_ease-in-out_infinite_0.8s]"
        {...motionProps}
      />
      <Diamond
        className="absolute ml:-top-60 ml:-left-120 -left-30 top-120 ml:w-260 w-100 animate-[move-up_3s_ease-in-out_infinite_1.2s]"
        {...motionProps}
      />
      <LighterCircle
        className="absolute -bottom-60 -left-70 ml:-bottom-100 ml:-left-150 ml:w-600 w-200 animate-[move-down_3s_ease-in-out_infinite_0.4s] "
        {...motionProps}
      />
      <LightPolygon
        className="absolute bottom-60 xl:bottom-200 m:bottom-100 left-20 ml:left-300 w-85 ml:w-200 animate-[move-down_3s_ease-in-out_infinite_1.1s]"
        {...motionProps}
      />
      <WhiteCircle
        className="absolute top-520 right-40 w-100 animate-[move-up_3s_ease-in-out_infinite_0.6s] hidden ml:block"
        {...motionProps}
      />
      <WhiteCircle
        className="absolute top-240 left-[37vw] w-80 opacity-60 animate-[move-up_3s_ease-in-out_infinite_0.9s] hidden ml:block"
        {...motionProps}
      />
      <WhiteCircle
        className="absolute top-270 ml:top-320 left-[3vw] w-20 ml:w-80 animate-[move-up_3s_ease-in-out_infinite_0.2s]"
        {...motionProps}
      />
      <WhiteCircle
        className="absolute bottom-20 ml:right-[42vw] right-100 w-20 ml:w-80 animate-[move-left_3s_ease-in-out_infinite_0.7s]"
        {...motionProps}
      />

      <SmallCircle
        className="absolute top-150 left-[13vw] w-180 animate-[move-up_3s_ease-in-out_infinite_1.3s] hidden ml:block"
        {...motionProps}
      />
      <Diamond
        className="absolute ml:bottom-100 bottom-100 left-[44vw] w-40 ml:w-90 animate-[move-right_3s_ease-in-out_infinite_0.5s]"
        {...motionProps}
      />

      <div className="max-w-screen-1850 p-main relative mx-auto">
        <motion.div
          className="flex flex-col items-center justify-center max-w-[250px] ml:max-w-[700px] mx-auto text-center ml:gap-28 gap-12 mt-150"
          {...defaultMotionProps}
          variants={{
            initial: {},
            animate: {
              transition: {
                staggerChildren: 0.15,
                delayChildren: 0.2,
              },
            },
          }}
        >
          <motion.span
            className="text-12 font-[440] leading-100 -tracking-1 ml:text-22 bg-electric-05 rounded-full px-30 py-8"
            variants={{
              initial: {
                opacity: 0,
                y: 20,
              },
              animate: {
                opacity: 1,
                y: 0,
              },
            }}
            transition={defaultMotionProps.transition}
          >
            2025
          </motion.span>
          <motion.h1
            className="text-cloud ml:text-[120px] text-[45px] font-normal leading-[80%] tracking-[-1.2px] trim-text"
            variants={{
              initial: {
                opacity: 0,
                y: 20,
              },
              animate: {
                opacity: 1,
                y: 0,
              },
            }}
            transition={defaultMotionProps.transition}
          >
            Data Rights Unwrapped
          </motion.h1>
          <motion.h2
            className="text-cipher-08 ml:text-[31px] text-[14px] font-light leading-[91%] tracking-[-0.31px] ml:mt-30 mt-5"
            variants={{
              initial: {
                opacity: 0,
                y: 20,
              },
              animate: {
                opacity: 1,
                y: 0,
              },
            }}
            transition={defaultMotionProps.transition}
          >
            Honoring data rights for an AI-first world
          </motion.h2>
        </motion.div>
      </div>
    </section>
  );
};
